export const UPLOAD = 'fileUpload/UPLOAD';
export { TYPE_IMAGE, TYPE_VIDEO } from '../services/request-credentials';

export const upload = (file, type, onSuccess) => ({
  type: UPLOAD,
  payload: {
    file,
    type,
    onSuccess,
  },
});



// WEBPACK FOOTER //
// ./app/actions/upload.js